<template>
  <section class="suppliercreate">
    <header class="header">
    </header>

    <form @submit.prevent="handleCreateSupplier">
      <f-card>
        <template slot="header"></template>
        <template>
          <div class="row">
            <span class="label">Informations Principales</span>
            <div class="inputs">
              <ab-input id="label" type="text" class="mandatory" v-model="label" name="label" label="Raison sociale"></ab-input>
              <div class="wrap">
                <ab-input type="email" class="input-group" v-model="email" name="email" label="Email"></ab-input>
                <ab-input type="text" class="input-group" v-model="phone" name="phone" label="Téléphone"></ab-input>
                <ab-input type="text" class="input-group" v-model="address" name="address" label="Siège social"></ab-input>
                <ab-input type="text" class="input-group" v-model="siret" name="siret" label="SIRET"></ab-input>
              </div>
            </div>
          </div>
        </template>

        <template slot="footer">
          <div class="row flex-container">
            <a class="btn-action" @click="$router.go(-1)">Annuler</a>
            <ab-button class="primary">Enregistrer</ab-button>
          </div>
        </template>
      </f-card>
    </form>
  </section>
</template>

<script>
  import AbInput from '@/components/form/input/ab-input.vue';
  import AbButton from '@/components/form/button/ab-button.vue';
  import FCard from '@/components/layout/card/f-card.vue';
  import { mapState } from 'vuex';
  // Import error message files
  import messages from '../../../messages/messages.js';

  export default {
    name: 'SupplierCreate',
    components: {
      AbInput,
      AbButton,
      FCard,
    },
    data() {
      return {
        label: '',
        email: '',
        phone: '',
        address: '',
        siret: '',
      }
    },
    methods: {
      async handleCreateSupplier() {
        const label = this.$el.querySelector('#label input');

        label.classList.remove('error');
        if (this.label) {
          const data = await this.$store.dispatch('createSupplier', {
            label: this.label,
            email: this.email,
            phone: this.phone,
            address_1: this.address,
            siret: this.siret
          });
          if (data.id) {
            this.displayToast({ message: messages.suppliers.SupplierCreate.custom.success });
            this.$router.push({ name: 'SupplierList' });
          } else {
            // TODO error case
          }
        } else { 
          label.classList.add('error');
          this.displayToast({ message: messages.suppliers.global.custom.mandatory, mode: "error" });
        }
      },
    }
  }
</script>

<style scoped>
  .row {
    margin-bottom: 1.5rem;
  }
  .row .label {
    color: var(--app-dark-grey);
    font-weight: 600;
    font-size: 15px;
    line-height: 27px;
    vertical-align: top;
    padding-right: 1.5rem;
  }
  .inputs {
    margin-top: 16px;
  }
  .wrap {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .input-group {
    width: 45%;
    /*justify-content: space-between;*/
  }
  /* Spacing for each section */
  section {
    margin-bottom: 2.5rem;
  }
  /* Footer */
  .flex-container {
    display: flex;
    justify-content: flex-end;
  }
  footer .btn-action {
    margin-right: 1rem;
    cursor: pointer;
  }
  .user-image{
    width:100%;
    border:2px dashed #90A0B7;
    padding:15px;
    margin: 15px 0;
    text-align:center;
  }
  .check-label {
    margin-right: 1rem;
  }
  .check-label:focus {
    outline: none;
  }
</style>